import useForm from '../../../hooks/useForm';
import { Grid, Typography, MenuItem } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import StyledModal from '../StyledModal';
import { Button, TextField } from '../../common';
import { admin } from '../../../utils/api';
import { voivodeships } from '../../../assets/consts';

export default function AddAccountModal(props) {
  const handleClose = () => props.setOpen(false);
  const { handleChange, values } = useForm({
    name: '',
    surname: '',
    email: '',
    department: '',
    permissionsLevel: '',
  });

  const handleAddAccount = () => {
    const body = {
      department: values.department,
      email: values.email,
      name: values.name,
      status: 'false',
      permissions: values.permissionsLevel,
      surname: values.surname,
    };
    admin
      .createUser(body)
      .then((result) => {
        handleClose();
        props.update();
      })
      .catch(() => {});
  };

  return (
    <>
      <StyledModal open={props.open} handleClose={handleClose}>
        <Grid container justifyContent="center">
          <Typography sx={{ fontSize: 36, fontWeight: 500, mb: 4, mt: 1 }}>
            Dodaj nowe konto
          </Typography>
        </Grid>
        <Grid container direction={'column'}>
          <Grid container justifyContent="left">
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <TextField
                modal
                label="Imię"
                onChange={handleChange('name')}
                inputProps={{ 'data-testid': 'add-name' }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <TextField
                modalRight
                label="Nazwisko"
                onChange={handleChange('surname')}
              />
            </Grid>
          </Grid>
          <Grid container>
            <TextField modal label="E-mail" onChange={handleChange('email')} />
          </Grid>
          <Grid container justifyContent="left">
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <TextField
                modal
                select
                label="Oddział"
                onChange={handleChange('department')}
              >
                {voivodeships.map((v) => (
                  <MenuItem value={v}>{v}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <TextField
                modalRight
                select
                label="Poziom uprawnień"
                onChange={handleChange('permissionsLevel')}
              >
                <MenuItem value="bankowiec">Bankowiec</MenuItem>
                <MenuItem value="admin">Admin</MenuItem>
              </TextField>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="right"
            alignContent="right"
            alignItems="right"
          >
            <Button
              variant="contained"
              onClick={handleAddAccount}
              sx={{ mt: 2, mr: 2 }}
            >
              <PersonAddIcon sx={{ mr: 2 }} />
              DODAJ NOWE KONTO
            </Button>
          </Grid>
        </Grid>
      </StyledModal>
    </>
  );
}
